// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"91":"f0a09fa3","677":"34be521c"}[chunkId] + ".chunk.js");